<template>
    <div id="basicInfo">
       <my-header></my-header>
        <div class="banner">
            <img src="../../assets/images/register/bg.jpg"/>
        </div>
        <div class="main-container basicMain">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本情况" name="0">
                    <div id="register">
                        <section class="small-container">
                            <h3>注册信息<span class="tips">请先提交"基本情况"后再完成其他页面 | 带*的必须填写</span></h3>
                            <el-form
                                :label-position="labelPosition"
                                :model="userForm"
                                :rules="registerRules"
                                status-icon
                                ref="userForm"
                                label-width="150px"
                                class="userForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="登录名：" prop="userName">
                                            <el-input v-model="userForm.userName" disabled  placeholder="登录名为手机号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="注册状态：" prop="registerStatusName" >
                                            <el-input v-model="userForm.registerStatusName" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="供应商状态：" prop="supplierStatusName">
                                            <el-input v-model="userForm.supplierStatusName" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>企业信息</h3>
                            <el-form :model="registerForm" :label-position="labelPosition" status-icon :rules="registerRules" ref="registerForm" label-width="250px" class="registerForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="企业名称：" prop="companyName">
                                            <el-input v-model="registerForm.companyName" @change="changeCompanyName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="纳税人状态：" prop="taxipayerStatus">
                                            <el-select v-model="registerForm.taxipayerStatus" placeholder="请选择">
                                                <el-option
                                                    v-for="item in taxiOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-if="registerForm.creditLicenseCodeFlag == 2" :span="24">
                                        <el-form-item label="营业执照号/统一社会信用代码：" prop="businessLicenseNumber" class="creditCode">
                                            <el-radio-group v-model="registerForm.creditLicenseCodeFlag">
                                                <el-radio :label="1">统一社会信用代码</el-radio>
                                                <el-radio :label="2">营业执照号</el-radio>
                                            </el-radio-group>
                                            <el-input required v-model="registerForm.businessLicenseNumber" type="text" placeholder="请输入13-15位营业执照号"></el-input>
                                            <span class="tip">(提示：三证合一的企业必须选择‘统一社会信用代码’)</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-else :span="24">
                                        <el-form-item label="营业执照号/统一社会信用代码：" prop="socialCreditCode" class="creditCode">
                                            <el-radio-group v-model="registerForm.creditLicenseCodeFlag">
                                                <el-radio :label="1">统一社会信用代码</el-radio>
                                                <el-radio :label="2">营业执照号</el-radio>
                                            </el-radio-group>
                                            <el-input required  v-model="registerForm.socialCreditCode" type="text" :maxlength="18" placeholder="请输入18位数字或字母"></el-input>
                                            <span class="tip">(提示：三证合一的企业必须选择‘统一社会信用代码’)</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item v-if="registerForm.creditLicenseCodeFlag == 2" label="税务登记证号：" prop="taxCertificateNumber">
                                            <el-input v-model="registerForm.taxCertificateNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="组织机构代码证号：" v-if="registerForm.creditLicenseCodeFlag == 2"  prop="orgCertificateNumber">
                                            <el-input v-model="registerForm.orgCertificateNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="营业期限：" class="contentFull">
                                            <el-date-picker
                                                v-model="registerForm.businessYearLimitedStart"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                                                type="date"
                                                placeholder="选择起始日期">
                                            </el-date-picker>
                                            至
                                            <el-date-picker
                                                v-model="registerForm.businessYearLimitedEnd"
                                                format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                                                type="date"
                                                placeholder="选择截止日期">
                                            </el-date-picker>
                                            <span class="tip">（提示：截止日期不填视为长期有效）</span>
                                        </el-form-item>
                                    </el-col>
                                    <!--<el-col :span="24">
                                        <el-form-item label="意向地区公司：" class="selectFull" prop="intentionRegionalCompanyIds">
                                            <el-select v-model="registerForm.intentionRegionalCompanyIds" multiple filterable placeholder="请选择意向地区公司">
                                                <el-option
                                                    v-for="item in intentionOptions"
                                                    :key="item.id"
                                                    :label="item.regionalCompanyName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>-->
                                    <el-col :span="24">
                                        <el-form-item label="可承接省份：" prop="undertakeAreas">
                                            <el-select v-model="registerForm.undertakeAreas" multiple filterable style="width:100%;" placeholder="请选择省" @change="handelSelectChangeFunc">
                                                <el-option
                                                    v-for="item in areaOptions"
                                                    :key="item.id"
                                                    :label="item.areaName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="供方服务类别：" class="selectFull" prop="supplierServiceCategoryIds" >
                                            <el-input disabled v-model="registerForm.supplierServiceCategoryNames"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="供方分类：" class="selectFull" prop="supplierCategoryIds">
                                            <el-input v-model="registerForm.supplierCategoryNames"
                                                      readonly
                                                      autosize
                                                      type="textarea"
                                        :maxlength="500"
                                                      class="textInput"
                                                      @focus="selectSuperiorName"
                                                      suffix-icon="el-icon-search"
                                                      placeholder="选择供方分类"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="体系认证：">
                                            <el-input v-model="registerForm.systemCertification"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所在区域：" prop="headquartersProvince">
                                            <el-select v-model="registerForm.headquartersProvince" filterable placeholder="请选择省">
                                                <el-option
                                                    v-for="item in areaOptions"
                                                    :key="item.id"
                                                    :label="item.areaName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="总部地址：" class="capitalAddr" prop="headquartersAddress">
                                            <el-input v-model="registerForm.headquartersAddress" placeholder="请输入总部地址"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row>
                                            <el-col :span="24">
                                                <el-form-item label="企业性质：" prop="enterpriseCharacterize" class="companyNature">
                                                    <el-select v-model="registerForm.enterpriseCharacterize" placeholder="请选择" style="width: 200px;">
                                                        <el-option
                                                            v-for="item in companyOptions"
                                                            :key="item.dictValue"
                                                            :label="item.dictLabel"
                                                            :value="item.dictValue">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <!-- <el-col v-if="registerForm.enterpriseCharacterize == '5'" :span="16">
                                                <el-form-item prop="enterpriseCharacterizeRemark" style="margin-left: 30px;">
                                                    <el-input v-model="registerForm.enterpriseCharacterizeRemark" placeholder="选择'其他'需填写"></el-input>
                                                </el-form-item>
                                            </el-col> -->
                                        </el-row>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业注册地址：" prop="enterpriseRegistAddress">
                                            <el-input v-model="registerForm.enterpriseRegistAddress"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="官网地址：">
                                            <el-input v-model="registerForm.officialWebUrl"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业成立日期：" prop="enterpriseRegistrationYear" >
                                            <el-date-picker
                                                v-model="registerForm.enterpriseRegistrationYear"
                                                :clearable=false
                                                align="right"
                                                type="month"
                                                id="buildDate"
                                                format="yyyy-MM"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="请选择日期">
                                            </el-date-picker>
                                            <!--<el-input class="unit" v-model="registerForm.name"></el-input>-->
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="员工总数：" prop="staffNumbers">
                                            <el-input v-model.number="registerForm.staffNumbers"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="是否上市公司：" style="margin-bottom: 22.5px;" prop="companyListed">
                                            <el-radio-group v-model="registerForm.companyListed">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="0">否</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="法定代表人：" prop="legalRepresentative">
                                            <el-input v-model="registerForm.legalRepresentative"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="是否全装联会员：" style="margin-bottom: 22.5px;" prop="fullMemberFlag">
                                            <el-radio-group v-model="registerForm.fullMemberFlag">
                                                <el-radio :label="1">是</el-radio>
                                                <el-radio :label="0">否</el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="法定代表人身份证号：" prop="legalRepresentativeIdNumber">
                                            <el-input v-model.trim="registerForm.legalRepresentativeIdNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="办公面积（m²）：" prop="officeArea">
                                            <el-input  v-model.number="registerForm.officeArea"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="注册资本：" class="capital" prop="registeredCapital">
                                            <el-input class="unit" v-model.number="registerForm.registeredCapital"></el-input>万元
                                            <span class="tip">（提示：外企请手动根据最新汇率换算成人民币，以此作为后期入围标准条件）</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>资质等级<span class="add iconfont iconjiahaoyou" @click="addNatural">新增</span><span class="tips" style="margin-right: 20px;">提示：资质有多个时请依次新增</span></h3>
                            <el-form v-if="isHideNatural" :label-position="labelPosition" label-width="125px" class="naturalForm">
                                <el-form-item label="资质等级：" >
                                    <span>无</span>
                                    <span class="tip">（提示：若无资质需要选择，请继续填写下方信息）</span>
                                </el-form-item>
                            </el-form>
                            <el-form v-else v-for="(naturalFormItem,index) in naturalForm" :label-position="labelPosition" status-icon :key="index" :model="naturalFormItem" :rules="naturalRules" :ref="'naturalForm'+index" label-width="125px" class="naturalForm">
                                <el-row :gutter="15">
                                    <el-col :span="7">
                                        <el-form-item label="资质名称：" prop="qualificationName" >
                                            <el-input v-model="naturalFormItem.qualificationName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="资质证书编号：" prop="certificateNumber">
                                            <el-input v-model="naturalFormItem.certificateNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="资质证书有效期：" required>
                                            <el-form-item class="validity" prop="validityPeriod">
                                                <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" v-model="naturalFormItem.validityPeriod" style="width: 100%;"></el-date-picker>
                                            </el-form-item>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2">
                                        <!--<el-form-item label="" ></el-form-item>-->
                                        <el-button @click="removeNatural(index)" class="add dele" style="margin-top: -3px;" type="text">删除</el-button>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="级别：" >
                                            <el-input v-model="naturalFormItem.gradeLevel"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="可承接范围：" >
                                            <el-input v-model="naturalFormItem.acceptableScope"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>股东<span class="add iconfont iconjiahaoyou" @click="addPartner">新增</span></h3>
                            <el-form v-for="(partnerFormItem,index) in partnerForm" :label-position="labelPosition" status-icon :key="index" :model="partnerFormItem" :rules="partnerRules" :ref="'partnerForm'+ index" label-width="100px" class="partnerForm">
                                <el-row >
                                    <el-col :span="11">
                                        <el-form-item label="股东：" prop="stockholderName">
                                            <el-input v-model="partnerFormItem.stockholderName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="身份证：" prop="stockholderCreditNumber" >
                                            <el-input v-model.trim="partnerFormItem.stockholderCreditNumber"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="2">
                                        <el-button v-show="index != 0" @click="removePartner(index)" class="add dele" style="margin-top: -3px;" type="text">删除</el-button>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3 style="margin-bottom: 5px;">联系方式</h3>
                            <div v-for="(contactFormItem,index) in contactForm" :key="index">
                                <h4 v-if="contactFormItem.mainFlag == 1">主联系人：<span class="tips" style="padding-left: 10px;">提示：职位是总经理或者副总经理级别的</span></h4>
                                <h4 v-else>联系人
                                    <span v-if="index == 1" @click="addContact" class="add iconfont iconjiahaoyou">新增</span>
                                    <span class="add dele" v-else @click="removeContact(index)">删除</span>
                                </h4>
                                <el-form :model="contactFormItem" :label-position="labelPosition" status-icon :rules="contactRules" :ref="'contactForm'+index" label-width="120px" class="contactForm">
                                    <el-row >
                                        <el-col :span="12">
                                            <el-form-item label="联系人：" prop="contactName">
                                                <el-input v-model="contactFormItem.contactName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="手机：" prop="mobile">
                                                <el-input :maxlength="11" v-model.trim="contactFormItem.mobile"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="电话：" >
                                                <el-input v-model="contactFormItem.phone"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="电子邮件：" prop="email">
                                                <el-input v-model="contactFormItem.email"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="身份证：" prop="creditNumber">
                                                <el-input v-model.trim="contactFormItem.creditNumber"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="职位：" prop="positionName">
                                                <el-input v-model="contactFormItem.positionName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </section>
                        <section class="small-container">
                            <h3>获取信息类型</h3>
                            <el-form :model="InfoTypeForm" :label-position="labelPosition" status-icon :rules="InfoTypeRules" ref="InfoTypeForm" label-width="150px" class="InfoTypeForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="推荐人类型：" prop="recommenderType">
                                            <el-select style="width:100%;" v-model="InfoTypeForm.recommenderType" placeholder="请选择">
                                                <el-option
                                                    v-for="item in recommendOptions"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-if="InfoTypeForm.recommenderType == 1 || InfoTypeForm.recommenderType == ''" :span="12">
                                        <el-form-item label="推荐人：" prop="recommenderName">
                                            <el-input v-model="InfoTypeForm.recommenderName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-if="InfoTypeForm.recommenderType == 1 || InfoTypeForm.recommenderType == ''" :span="12">
                                        <el-form-item label="推荐人单位：" prop="recommenderUnit">
                                            <el-input v-model="InfoTypeForm.recommenderUnit"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-if="InfoTypeForm.recommenderType == 1 || InfoTypeForm.recommenderType == ''" :span="12">
                                        <el-form-item label="推荐人联系电话：" prop="recommenderPhone">
                                            <el-input :maxlength="11" v-model="InfoTypeForm.recommenderPhone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="14">
                                        <el-form-item label="说明：" prop="recommenderIllustration">
                                            <el-input :rows="3" type="textarea"
                                        :maxlength="500" autosize v-model="InfoTypeForm.recommenderIllustration"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>关联母公司信息<span class="tips">提示：只能关联在合生商业供应商外网注册过的母公司信息</span></h3>
                            <el-form :model="affiliateForm" :label-position="labelPosition" status-icon :rules="affiliateRules" ref="affiliateForm" label-width="250px" class="affiliateForm">
                                <el-form-item label="有无关联母公司：" prop="hasRelateParentCompany">
                                    <el-radio-group v-model="affiliateForm.hasRelateParentCompany">
                                        <el-radio :label="1">有</el-radio>
                                        <el-radio :label="0">无</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-row v-if="affiliateForm.hasRelateParentCompany == 1">
                                    <el-col :span="12">
                                        <el-form-item label="关联母公司名称：" prop="relateParentCompanyId">
                                            <el-select style="width:100%;" @change="changeCompany" filterable v-model="affiliateForm.relateParentCompanyId" placeholder="请选择关联母公司名称">
                                                <el-option
                                                    v-for="item in relateOptions"
                                                    :key="item.id"
                                                    :label="item.relateParentCompanyName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="法人：" required>
                                            <el-input v-model="affiliateForm.legalRepresentative" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="营业执照号/统一社会信用代码：" required>
                                            <el-input v-if="affiliateForm.socialCreditCode" v-model="affiliateForm.socialCreditCode"  disabled></el-input>
                                            <el-input v-else v-model="affiliateForm.businessLicenseNumber" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="注册地址：" required>
                                            <el-input v-model="affiliateForm.registAddress" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>业务状况</h3>
                            <el-form :model="businessForm" :label-position="labelPosition" status-icon :rules="businessRules" ref="businessForm" label-width="250px" class="businessForm">
                                <el-row>
                                   <!-- <el-col :span="12">
                                        <el-form-item label="主要业务区域：" prop="mainBusinessAreaIds">
                                            <el-input v-model="businessForm.mainBusinessAreaIds" placeholder="请输入主要业务区域"></el-input>
                                        </el-form-item>
                                    </el-col>-->
                                    <el-col :span="12">
                                        <el-form-item label="上年营业额：" prop="lastYearSales">
                                            <el-input class="unit" v-model.number="businessForm.lastYearSales"></el-input>万元
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="平均年产能：" >
                                            <el-input v-model="businessForm.avgAnnualCapacity"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地地址：" >
                                            <el-input v-model="businessForm.processBaseAddress"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地负责人：" >
                                            <el-input v-model="businessForm.processBaseChargePerson"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地联系方式：" >
                                            <el-input v-model="businessForm.processBaseContactMode"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地规模：" >
                                            <el-input v-model="businessForm.processBaseScale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="加工基地设备：" >
                                            <el-input v-model="businessForm.processBaseEquipment"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司技术力量：" >
                                            <el-input v-model="businessForm.technicalAbility"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司劳动力组织：" >
                                            <el-input v-model="businessForm.laborForceOrg"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container">
                            <h3>备注<span class="tips">提示：字数限制500汉字</span></h3>
                            <el-input class="remarks" v-model="registerForm.remarks" style="margin-top: 20px;" :rows="5" :maxlength='500' type="textarea" ></el-input>
                        </section>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="近三年业绩" name="1">
                    <div id="achievement">
                        <div class="small-container strategy" v-if="activeName=='1'">
                            <el-form :model="strategyFormItem" v-for="(strategyFormItem,index) in strategyForm" :key="index" :label-position="labelPosition" :ref="'strategyForm'+index" :rules="numberRules" label-width="160px" class="strategyForm">
                                <h3>
                                    <span >战略合作</span>
                                    <span class="add iconfont iconjiahaoyou" v-if="index == 0" @click="addStrategy">新增</span>
                                    <span class="add dele" v-else @click="removeStrategy(index)">删除</span>
                                </h3>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="合作单位名称：" >
                                            <el-input v-model="strategyFormItem.cooperativeUnitName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作类别：" >
                                            <el-input v-model="strategyFormItem.cooperativeCategoryName"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item class="time" label="合作起止时间：" >
                                            <el-form-item >
                                                <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :id="'cooperativeStartTime'+index" v-model="strategyFormItem.cooperativeStartTime" style="width: 42%;"></el-date-picker>
                                                -
                                                <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :id="'cooperativeEndTime'+index" v-model="strategyFormItem.cooperativeEndTime" style="width: 42%;"></el-date-picker>
                                            </el-form-item>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所获奖项：" >
                                            <el-input v-model="strategyFormItem.awards"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作区域：">
                                            <el-input v-model="strategyFormItem.cooperativeAreaName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作额度：" prop="cooperationAmount">
                                            <el-input class="unit" v-model="strategyFormItem.cooperationAmount"></el-input>万元
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="合同附件:">
                                            <page-upload :files="strategyFormItem.lstattachmentVO"
                                                         :editFlag="true"
                                                         :attachmentType="1"
                                                        :limitType="1"
                                                         :isIconTable="1"></page-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                        <div class="small-container strategy" v-if="activeName=='1'">
                            <el-form :model="commonFormItem" v-for="(commonFormItem,index) in commonForm" :key="index" :label-position="labelPosition" :ref="'commonForm'+index" :rules="numberRules" label-width="160px" class="strategyForm">
                                <h3>
                                    一般合作
                                    <span class="add iconfont iconjiahaoyou" v-if="index == 0" @click="addCommon">新增</span>
                                    <span class="add dele" v-else @click="removeCommon(index)">删除</span>
                                    <span v-if="index == 0" class="tips">提示：请输入至少3项除战略合作外的合作项目</span>
                                </h3>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="合作单位名称：" >
                                            <el-input v-model="commonFormItem.cooperativeUnitName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" >
                                        <el-form-item label="合作项目：" >
                                            <el-input v-model="commonFormItem.cooperativeProjectName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="项目规模：">
                                            <el-input v-model="commonFormItem.cooperativeProjectScale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作范围：" >
                                            <el-input v-model="commonFormItem.cooperationScope"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作区域：">
                                            <el-input v-model="commonFormItem.cooperativeAreaName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="合作额度：" prop="cooperationAmount">
                                            <el-input class="unit" v-model="commonFormItem.cooperationAmount"></el-input>万元
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="合同附件:">
                                            <page-upload :files="(commonFormItem.lstattachmentVO || [])"
                                                         :editFlag="true"
                                                         :attachmentType="1"
                                                        :limitType="1"
                                                         :isIconTable="1"></page-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="附件清单" name="2">
                    <div id="annex">
                        <div class="small-container">
                            <h3 class="tab-icon-fileList">附件清单<span class="tips">带*的必须上传，供方在上传多页扫描件时合并后再上传</span></h3>
                            <div class="clearfix">
                                <el-form :model="annexForm" :rules="annexRules" v-if="activeName=='2'" ref="annexForm" label-width="360px" class="annexForm">
                                    <el-form-item v-for="(item,key) in mapAttachmentOptions"
                                                  :key="key"
                                                  :prop="(key < 3 || (key == 11 && isChangeCompanyName)) ? 'fileList' : ''"
                                                  :label="item.label+':'">
                                        <page-upload :files="item.fileList"
                                                     :editFlag="true"
                                                     :attachmentType="key"
                                                    :limitType="1"
                                                     :isIconTable="1"></page-upload>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="审核记录" name="3">
                    <el-table
                        class="recordTable"
                        ref="recordTable"
                        :data="tableData"
                        highlight-current-row
                        style="width: 100%">
                        <el-table-column
                            type="index"
                            label="序号"
                            width="80">
                        </el-table-column>
                        <el-table-column
                            property="nodeName"
                            label="审核类型">
                        </el-table-column>
                        <el-table-column
                            property="setupTime"
                            label="发起时间">
                        </el-table-column>
                        <el-table-column
                            property="actionName"
                            label="审核状态">
                        </el-table-column>
                        <el-table-column
                            property="createDate"
                            label="审核时间">
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            label="操作">
                            <template slot-scope="scope">
                                <el-button @click="handleTableClick(scope.row)" type="text" size="small">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="修改密码" name="4">
                    <div id="changePass">
                        <main class="main-container">
                            <div class="right_text">
                                <el-form label-position="left" :model="changePassForm" status-icon :rules="changeRules" ref="changePassForm" label-width="118px">
                                    <el-form-item label="原密码：" prop="oldPassword">
                                        <el-input type="password" :maxlength="20" v-model.trim="changePassForm.oldPassword" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="新密码：" prop="password">
                                        <el-input type="password" :maxlength="20" v-model.trim="changePassForm.password" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="确认新密码：" prop="enPass">
                                        <el-input type="password" :maxlength="20" v-model.trim="changePassForm.enPass" auto-complete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item size="large">
                                        <el-button type="primary" @click="submitForm('changePassForm')">确认修改</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </main>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div style="margin: 10px 0 10px;">
                <el-button type="primary" v-if="activeName < 3" style="padding: 12px 50px;font-size: 16px;" @click="submit" :disabled="editFlage!=1">提交</el-button>
            </div>
        </div>
        <!--供应商分类树形-->
        <el-dialog
            title="选择供应商分类"
            :visible.sync="tree.supplierCategoryDialog"
            width="40%"
            :close-on-click-modal="$root.dialogAutoClose"
            :close-on-press-escape="$root.dialogAutoClose"
            :before-close="handleCloseSupplierCategory">
            <div style="max-height: 300px;overflow-y: auto;">
                <el-tree :data="tree.supplierCategoryTreeData"
                         :props="tree.supplierCategoryTreeDataDefaultProps"
                         default-expand-all
                         highlight-current
                         :expand-on-click-node="false"
                         :show-checkbox="true"
                         :default-checked-keys="tree.defaultKeys"
                         node-key="id"
                         ref="treeSupplierCategory"
                         @node-click="handleCheckChange"></el-tree>
            </div>
            <span slot="footer" class="dialog-footer">
            <el-button @click="handleCloseSupplierCategory">取 消</el-button>
            <el-button type="primary" @click="handleConfirmSupplierCategory">确 定</el-button>
        </span>
        </el-dialog>
        <!--审核记录的查看详情-->
        <el-dialog :visible.sync="dialogTableVisible" class="tableInfo">
            <el-table :data="tableInfoData" max-height="420">
                <el-table-column property="classFieldName" label="修改字段名称" width="160" ></el-table-column>
                <el-table-column property="modifiedBeforeName" label="原值" >
                    <template slot-scope="scope">
                        <el-popover
                            ref="popover1"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="scope.row.modifiedBeforeName">
                            <span slot="reference">{{scope.row.modifiedBeforeName}}</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column property="modifiedAfterName" label="调整后值">
                    <template slot-scope="scope">
                        <el-popover
                            ref="popover2"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="scope.row.modifiedAfterName">
                            <span slot="reference">{{scope.row.modifiedAfterName}}</span>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
    import md5 from 'js-md5';
    import MyHeader from './MasterHeader.vue';
    import { registerRules,naturalRules,partnerRules,contactRules,InfoTypeRules,affiliateRules,businessRules,numberRules,annexRules } from '../../util/rules';
    import ElTabPane from "../../../node_modules/element-ui/packages/tabs/src/tab-pane.vue";

    export default {
        name: 'master-basicInfo',
        data() {
            return {
                editFlage: '', //1 可以修改 0不可
                qualifiedFlag: '',//1需要走变更流程，0 不用走变更， （是否会弹出变更提示框）
                userForm: {
                    userName: '',//登录名
                    registerStatusName: '',//注册状态
                    supplierStatusName: ''//供应商状态
                },
                registerForm: {
                    companyName:'',//企业名称
                    taxipayerStatus: '',//纳税人状态
                    taxipayerStatusName: '',//纳税人状态名称
                    socialCreditCode: '',//统一社会信用代码
                    businessLicenseNumber: '',//营业执照号
                    taxCertificateNumber: '',//税务登记证号
                    orgCertificateNumber: '',//组织机构代码证号
                    intentionRegionalCompanyIds: '',//意向地区公司ids
                    intentionRegionalCompanyIdsArr: [],//意向地区公司ids
                    intentionRegionalCompanyNames: '',//意向地区公司名称
                    supplierServiceCategoryIds: '',//供方服务类别
                    supplierServiceCategoryNames: '',//供方服务类别名称
                    supplierCategoryIds: '',//供方分类ids
                    supplierCategoryNames: '',//供方分类名称
                    systemCertification: '',//体系认证
                    headquartersProvince: '',//总部地址省id
                    headquartersProvinceName: '',//总部地址省名称
                    headquartersCity: '',//总部地址市id
                    headquartersCityName: '',//总部地址市名称
                    headquartersArea: '',//总部地址区id
                    headquartersAreaName: '',//总部地址区名称
                    headquartersAddress: '',//总部地址
                    enterpriseCharacterize: '',//企业性质
                    enterpriseCharacterizeName: '',//企业性质名称
                    enterpriseCharacterizeRemark: '',//企业性质其他名称
                    officialWebUrl: '',//官网地址
                    enterpriseRegistAddress: '',//企业注册地址
                    legalRepresentative: '',//法定代表人
                    legalRepresentativeIdNumber: '',//法定代表人身份证号
                    enterpriseRegistrationYear: '',//企业成立日期
                    officeArea: '',//办公面积
                    registeredCapital: '',//注册资本
                    remarks: '',//备注信息
                    creditLicenseCodeFlag: 1,//单选，统一社会信用代码1 或 营业执照2
                    businessYearLimitedStart: '',//营业期限开始
                    businessYearLimitedEnd: '',//营业期限结束
                    companyListed: 0,//单选，是否上市公司（0：否，1：是）
                    fullMemberFlag: 0,//单选，是否全装联会员（0：否，1：是）
                    staffNumbers: '',//员工总数
                    headquartersProvince: '',//所在区域省份id
                    headquartersProvinceName: '',//所在区域省份名称
                    undertakeAreas: []//可承接省份
                },
                registerRules: registerRules,
                isChangeCompanyName: false,
                naturalForm: [//资质等级
                    /*{
                        qualificationName:'',//资质名称
                        certificateNumber:'',//资质证书编号
                        validityPeriod:'',//资质证书有效期
                    }*/
                ],
                isHideNatural: true,//是否隐藏资质等级输入框；
                naturalRules: naturalRules,
                partnerForm: [//股东
                    {
                        stockholderName:'',//股东姓名
                        stockholderCreditNumber:''//股东身份证
                    }
                ],
                partnerRules: partnerRules,
                contactForm: [//联系方式
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'1'//是否主联系人（0：否，1：是）}
                    },
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'0'//是否主联系人（0：否，1：是）}
                    }
                ],
                contactRules: contactRules,
                InfoTypeForm:{ //获取信息类型
                    recommenderType:'',//推荐人类型
                    recommenderTypeName:'',//推荐人类型名称
                    recommenderName:'',//推荐人姓名
                    recommenderUnit:'',//推荐人单位
                    recommenderPhone:'',//推荐人电话
                    recommenderIllustration:''//推荐人说明
                },
                InfoTypeRules: InfoTypeRules,
                affiliateForm: {//获取关联母公司信息
                    hasRelateParentCompany:'',//有无关联母公司（0：否，1：是）
                    relateParentCompanyId: '',//关联母公司Id
                    relateParentCompanyName:'',//关联母公司名称
                    legalRepresentative:'',//法人
                    socialCreditCode:'',//统一社会信用代码
                    businessLicenseNumber:'',//营业执照号
                    creditLicenseCodeFlag: '',//1 代表统一社会信用代码，2 代表营业执照号
                    registAddress:'',//注册地址
                },
                affiliateRules: affiliateRules,
                businessForm: {//业务状况
                    mainBusinessAreaIds:'',//主要业务区域ids
                    mainBusinessAreaNames:'',//主要业务区域名称
                    lastYearSales:'',//上年营业额
                    avgAnnualCapacity:'',//平均年产能
                    processBaseAddress:'',//加工基地地址
                    processBaseChargePerson:'',//加工基地负责人
                    processBaseContactMode:'',//加工基地联系方式
                    processBaseScale:'',//加工基地规模
                    processBaseEquipment:'',//加工基地设备
                    technicalAbility:'',//公司技术力量
                    laborForceOrg:''//公司劳动力组织
                },
                businessRules: businessRules,
                strategyForm: [//近三年業績 战略合作
                    {
                        cooperativeUnitName: '',//合作单位名称
                        cooperativeCategoryName: '',//合作类别名称
                        cooperativeStartTime: '',//合作起始时间
                        cooperativeEndTime: '',//合作截止时间
                        awards: '',//所获奖项
                        cooperativeAreaName: '',//合作区域名称
                        cooperationAmount: '',//合作额度
                        lstattachmentVO: [] //合同附件
                    }
                ],
                commonForm: [//一般合作
                    {
                        cooperativeUnitName: '',//合作单位名称
                        cooperativeProjectName: '',//合作项目名称
                        cooperativeProjectScale: '',//项目规模
                        cooperationScope: '',//合作范围
                        cooperativeAreaName: '',//合作区域名称
                        cooperationAmount: '',//合作额度
                        lstattachmentVO: [] //合同附件
                    }
                ],
                numberRules: numberRules,
                mapAttachmentOptions: {
                    2: {
                        label: '营业执照/统一社会信用代码',
                        fileList: []
                    },
                    3: {
                        label: '增值税纳税人申请认定表',
                        fileList: []
                    },
                    4: {
                        label: '上年审计报告或年营业额证明文件',
                        fileList: []
                    },
                    5: {
                        label: '质量保证体系认证文件',
                        fileList: []
                    },
                    6: {
                        label: '安全生产许可证',
                        fileList: []
                    },
                    7: {
                        label: '生产经营许可证',
                        fileList: []
                    },
                    8: {
                        label: '资质等级证书',
                        fileList: []
                    },
                    9: {
                        label: '管理体系认证',
                        fileList: []
                    },
                    10: {
                        label: '认证或荣誉证书',
                        fileList: []
                    },
                    11: {
                        label: '供方名称变更单(工商局盖章版)',
                        fileList: []
                    },
                    12: {
                        label: '其他附件',
                        fileList: []
                    }
                },
                annexForm: {//附件清单
                },
                annexRules: {
                    fileList: [
                        { message: '附件不能为空',type: 'array',required: true }
                    ]
                },
                taxiOptions: [],//纳税人状态
                companyOptions: [],//企业性质
                recommendOptions: [],//推荐人类型
                intentionOptions: [],//意向地區公司
                relateOptions: [],//關聯母公司信息
                areaOptions: [],//所在区域信息
                activeName: '0',//tabs切换名称；
                centerDialogVisible: false,//是否显示注册须知；
                showModal: false,//是否显示弹层遮罩层及关闭按钮
                checked: true,//注册须知是否勾选了已阅读；
                labelPosition: 'right',//表单里的label定位
                tree: {//供方分类树形弹框
                    supplierCategoryTreeData: [], //供方分类树形数据
                    supplierCategoryTreeDataDefaultProps:  {
                        children: 'children',
                        label: 'text'
                    },
                    supplierCategoryDialog: false,  //供方分类弹出框
                    defaultKeys: [],
                },
                canSubmit: false,//是否可以提交表单；
                changePassForm: {//修改密码
                    oldPassword: '',
                    password: '',
                    enPass: ''
                },
                changeRules: {//修改密码校验规则
                    oldPassword: [
                        {required: true, message: '请输入原密码'},
                        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入新密码'},
                        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'},
                        {validator: this.validateNewPass, trigger: 'blur'}
                    ],
                    enPass: [
                        {required: true, message: '请再次输入新密码'},
                        {
                            validator: 'regexp',
                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
                            message: '密码为6-20位数字和字母的组合',
                            trigger: 'blur'
                        },
                        {validator: this.validateNewPass2, trigger: 'blur'}
                    ]
                },
                tableData: [],//审核记录的数据
                dialogTableVisible: false,//是否显示审核记录弹窗；
                tableInfoData: [],//审核记录查看按钮弹窗里的表格数据；
                currentPage: 1,//分页当前页；
                pageSize: 10,//分页每页显示数量
                pageTotal: 0//分页总条数
            }
        },
        components: {
            ElTabPane,
            MyHeader
        },
        created(){
            this.$root.activeIndex = 'invite';
            this.activeName = window.sessionStorage.getItem('activeNum') || '0';
            window.sessionStorage.setItem('activeNum','');
            var obj = {
                password: [
                    {required: true, message: '请输入登录密码', trigger: 'blur'},
                    {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'},
                    {validator: this.validatePass, trigger: 'blur'}
                ],
                enPassword: [
                    {required: true, message: '请再次输入登录密码', trigger: 'blur'},
                    {
                        validator: 'regexp',
                        pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
                        message: '密码为6-20位数字和字母的组合',
                        trigger: 'blur'
                    },
                    {validator: this.validatePass2, trigger: 'blur'}
                ],
                socialCreditCode:[
                    {required: true, message: '18位数字或字母'},
                    { validator: this.checkSocialCode, trigger: 'blur'}
                ],
                businessLicenseNumber:[
                    {required: true, message: '13-15位数字或字母'},
                    { validator: this.checkSocialCode, trigger: 'blur'}
                ]
            };
            this.registerRules = Object.assign(obj,this.registerRules);//增加密码校验规则；
            var _this = this;

            getType('taxipayer_status');//获取纳税人状态
            getType('enterprise_characterize');//获取企业性质
            getType('recommender_type');//获取推荐人类型
            getCompany();//獲取母公司，意向地區公司
            getAllInfo();//获取所有信息

            function getType(type){
                _this.$root.getHttp('v1/sysDict/public/getDictListByDictType?dictType='+type,function(res){
                    if(type == 'taxipayer_status'){
                        _this.taxiOptions = res.data.data;//获取纳税人状态
                    } else if(type == 'enterprise_characterize'){
                        _this.companyOptions = res.data.data;//获取企业性质
                    } else if(type == 'recommender_type'){
                        _this.recommendOptions = res.data.data;//获取推荐人类型
                    }
                });
            }
//            v1/sRegionalCompany/getRegionalCompanyList
            function getCompany(){
               /* _this.$root.postHttp('v1/sRegionalCompany/public/getRegionalCompanyList',{//獲取意向地區公司
                    "pageFlag": 0,
                    "pageNumber": 0,
                    "pageSize": 0,
                    "regionalCompanyCode": "",
                    "regionalCompanyName": ""
                },function(res){
                    _this.intentionOptions = res.data.data.list;
                });*/
//            relateOptions//獲取关联母公司
                _this.$root.getHttp('v1/sSuppliers/public/getParentCompanyList', function(res){
                    _this.relateOptions = res.data.data || [];
                });
                _this.$root.postHttp('v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{
                    "categoryStatus": '1',
                    "pageFlag": 0,
                    "pageNumber": 0,
                    "pageSize": 0
                },function(res){
                    _this.tree.supplierCategoryTreeData = res.data.data.tree;
                });
                //            获取所在区域省份
                _this.$root.getHttp('/v1/sysArea/public/allList', function (res) {
//                    console.log('所在区域',res)
                    _this.areaOptions = res.data.data || [];
                });
            }
          function getAllInfo(){//获取所有信息
//            获取所有基本信息；v1/sSuppliers/getSSuppliers/{id}
              _this.$root.getHttp('/v1/sSuppliers/getSSuppliers/'+ window.sessionStorage.getItem('loginId'),function(res){
                  _this.editFlage = res.data.data.editFlage; //是否可以提交  1 可以 0不可
                  _this.qualifiedFlag = res.data.data.qualifiedFlag; //修改后是否需要走变更流程 1 合格 ，需要走； 0，不用走
                  _this.registerForm = res.data.data.suppliersVO;//企业信息
                  _this.naturalForm = res.data.data.lstSuppliersQualificationGradeVO;//资质等级
                  _this.partnerForm = res.data.data.lstSuppliersStockHolderVO;//股东
                  _this.contactForm = res.data.data.lstSuppliersContactInfoVO;//联系方式
                  _this.InfoTypeForm = res.data.data.suppliersObtainInformationVO;//信息类型
                  _this.affiliateForm = res.data.data.suppliersRelateParentCmpyVO;//关联母公司
                  _this.businessForm = res.data.data.suppliersBusinessSituationVO;//业务状况
                  _this.strategyForm = res.data.data.lstSuppliersLastThreeMajorAchievenVO;//战略合作
                  _this.commonForm = res.data.data.lstSuppliersLastThreeCommonAchievenVO;//一般合作

                  if(_this.registerForm.modifiedFlag == 1){
                      _this.$alert('您当前处于【修改审批中】不能修改任何信息！',{
                          type: 'warning'
                      })
                  }else if(_this.editFlage == 0){
                      _this.$alert('您当前处于【入库审批中】不能修改任何信息！',{
                          type: 'warning'
                      })
                  }

//console.log('合同附件',_this.strategyForm,_this.commonForm)
                  //附件清单
                  for(let key in res.data.data.mapAttachmentVOs){
                      if(key>=2 && key<=12){
                          _this.mapAttachmentOptions[key].fileList = res.data.data.mapAttachmentVOs[key];
                      }
                  }
                  _this.registerForm.creditLicenseCodeFlag = res.data.data.suppliersVO.creditLicenseCodeFlag || 1;//如果内网注册的没有选择该选项，就默认选择 统一社会信用代码；
                  _this.registerForm.intentionRegionalCompanyIds = res.data.data.suppliersVO.intentionRegionalCompanyIds;//意向地区公司
                  _this.registerForm.undertakeAreas = res.data.data.suppliersVO.undertakeAreas ? res.data.data.suppliersVO.undertakeAreas.split(',') : [];//可承接省份
                  _this.registerForm.companyListed = res.data.data.suppliersVO.companyListed || 0;//是否上市公司，默认否；
                  _this.registerForm.enterpriseRegistrationYear = res.data.data.suppliersVO.enterpriseRegistrationYear ? (res.data.data.suppliersVO.enterpriseRegistrationYear).toString() : '';//日期；
                  _this.registerForm.taxipayerStatus = res.data.data.suppliersVO.taxipayerStatus ? (res.data.data.suppliersVO.taxipayerStatus).toString() : '';//纳税人状态；
                  _this.registerForm.enterpriseCharacterize = res.data.data.suppliersVO.enterpriseCharacterize ? (res.data.data.suppliersVO.enterpriseCharacterize).toString() : '';//企业性质；
                  _this.InfoTypeForm.recommenderType = res.data.data.suppliersObtainInformationVO.recommenderType ? (res.data.data.suppliersObtainInformationVO.recommenderType).toString() : '';//推荐人类型；
                  _this.userForm.userName = res.data.data.suppliersVO.userName;
                  _this.userForm.registerStatusName = res.data.data.suppliersVO.registerStatusName;
                  _this.userForm.supplierStatusName = res.data.data.suppliersVO.supplierStatusName;

                  if(_this.naturalForm.length){
                      _this.isHideNatural = false;
                      res.data.data.lstSuppliersQualificationGradeVO.forEach( (item,index) => {//把时间戳转换为日期对象；
                          _this.naturalForm[index].validityPeriod = item.validityPeriod ? (item.validityPeriod).toString() : '';
                      })
                  }
                  _this.tableData = res.data.data.lstHistoryCommentOutVO;//审核记录数据;
                  _this.pageTotal = _this.tableData.length;
                  if(_this.tableData.length){
                      _this.tableData.forEach( (item,i) => {
                          item.createDate = item.createDate.split(' ')[0];
                          item.setupTime = item.setupTime.split(' ')[0];
                      })
                  }

              });
          }
        },
        mounted(){},
        methods: {
            handelSelectChangeFunc(val){//根据可承接省份，来动态获取意向地区公司；
                let that = this;
                let companyIdsArr = [];
                val.find(function (item) {
                    let obj = that.areaOptions.find(function (value) {
                        if(value.id == item) return value;
                    });
                    if(obj.companyIds){
                        companyIdsArr = companyIdsArr.concat(obj.companyIds.split(','));
                    }
                });
//                console.log('省份',companyIdsArr)
                that.registerForm.intentionRegionalCompanyIdsArr = that.$root.uniqueArr(companyIdsArr);
                that.registerForm.intentionRegionalCompanyIds = that.$root.uniqueArr(companyIdsArr).join(',');
                that.registerForm.undertakeAreas = val;
            },
            handleCurrentPageChange(val) {//分页
                console.log(`当前页: ${val}`);
            },
            handleTableClick(row){
                var _this = this;
                this.$root.getHttp('/v1/sSuppliers/getChangesLog?relatedId='+ row.id,function(res){
                    _this.tableInfoData = res.data.data;
                    _this.dialogTableVisible = true;
                })
            },
            validateNewPass(rule, value, callback){//验证新密码，修改密码页面
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.changePassForm.enPass !== '') {
                        this.$refs.changePassForm.validateField('enPass');
                    }
                    callback();
                }
            },
            validateNewPass2(rule, value, callback){//验证确认新密码，修改密码页面
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.changePassForm.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            },
            submitForm(formName) {//修改密码提交；
                var _this = this;
//                console.log('修改密码');
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        _this.$root.postHttp('/v1/login/public/changePassword',{
                            "passwordNew": md5(_this.changePassForm.password),
                            "passwordOld": md5(_this.changePassForm.oldPassword)
                        },function(res){
//                            console.log('submit')
                            _this.$alert('修改密码成功', '提示', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: action => {
                                    _this.$router.push('/master/center');
                                }
                            });
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            checkSocialCode(rule,value,callback){//校验统一社会信用代码或者营业执照号是否存在
//                console.log(value)
                var _this = this;
                this.$http.post('/v1/sSuppliers/public/checkCodeOrNumber',{
                    "businessLicenseNumber": _this.registerForm.businessLicenseNumber,
                    "creditLicenseCodeFlag": _this.registerForm.creditLicenseCodeFlag,
                    "socialCreditCode":  _this.registerForm.socialCreditCode,
                    "supplierId":  window.sessionStorage.getItem('loginId')
                }).then( (res) => {
                    if(res.data.code == 1){
                        callback();
                    } else {
                        callback(new Error(res.data.msg));
                    }
                })
            },
            changeCompany(val){//关联母公司选项改变时触发；
                var _this = this;
                this.relateOptions.forEach( (item,index) => {
                    if(item.id == val){
                        _this.affiliateForm.registAddress = item.registAddress;
                        _this.affiliateForm.socialCreditCode = item.socialCreditCode;
                        _this.affiliateForm.legalRepresentative = item.legalRepresentative;
                        _this.affiliateForm.creditLicenseCodeFlag = item.creditLicenseCodeFlag;
                    }
                })
            },
            validatePass(rule, value, callback){//验证密码
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.userForm.enPassword !== '') {
                        this.$refs.userForm.validateField('enPassword');
                    }
                    callback();
                }
            },
            validatePass2(rule, value, callback){//验证确认密码
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.userForm.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            },
            addNatural(){//新增资质等级
                this.isHideNatural = false;
                this.naturalForm.push(
                    {
                        qualificationName:'',//资质名称
                        certificateNumber:'',//资质证书编号
                        validityPeriod:'',//资质证书有效期
                    }
                );
            },
            removeNatural(index){//删除资质等级
                var form = 'naturalForm'+index;
                this.$refs[form][0].clearValidate();
                this.naturalForm.splice(index,1);
                if(this.naturalForm.length == 0){
                    this.isHideNatural = true;
                }
                for(var i = 0;i < this.naturalForm.length;i++){
                    this.$refs['naturalForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            addPartner(){//新增股东
                this.partnerForm.push(
                    {
                        stockholderName:'',//股东姓名
                        stockholderCreditNumber:''//股东身份证
                    }
                );
            },
            removePartner(index){//删除股东
                var form = 'partnerForm'+index;
                this.$refs[form][0].resetFields();
                this.partnerForm.splice(index,1);
                for(var i = 0;i < this.partnerForm.length;i++){
//                    console.log(this.$refs['partnerForm'+i])
                    this.$refs['partnerForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            addContact(){//新增联系人
                this.contactForm.push(
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'0'//是否主联系人（0：否，1：是）}
                    }
                );
            },
            removeContact(index){//删除联系人
                var form = 'contactForm'+index;
                this.$refs[form][0].resetFields();
                this.contactForm.splice(index,1);
                for(var i = 1;i < this.contactForm.length;i++){
                    this.$refs['contactForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            addStrategy(){//添加战略合作
                var _this = this;
                var item = {
                    cooperativeUnitName: '',//合作单位名称
                    cooperativeCategoryName: '',//合作类别名称
                    cooperativeStartTime: '',//合作起始时间
                    cooperativeEndTime: '',//合作截止时间
                    awards: '',//所获奖项
                    cooperativeAreaName: '',//合作区域名称
                    cooperationAmount: '',//合作额度
                    lstattachmentVO: [] //合同附件
                };
                _this.strategyForm.push(item);
            },
            removeStrategy(index){//移除战略合作
//                var form = 'strategyForm'+index;
//                this.$refs[form][0].resetFields();
                this.strategyForm.splice(index,1);
            },
            addCommon(){//添加一般合作
                var _this = this;
                var item = {
                    cooperativeUnitName: '',//合作单位名称
                    cooperativeProjectName: '',//合作项目名称
                    cooperativeProjectScale: '',//项目规模
                    cooperationScope: '',//合作范围
                    cooperativeAreaName: '',//合作区域名称
                    cooperationAmount: '',//合作额度
                    lstattachmentVO: [] //合同附件
                };
                _this.commonForm.push(item);
            },
            removeCommon(index){//移除一般合作
//                var form = 'commonForm'+index;
//                this.$refs[form][0].resetFields();
                this.commonForm.splice(index,1);
            },
            handleClick(tab, event) {//tabs标签页切换
//                console.log(tab, event);
            },
            recursiveTreeData(arr){
                let that = this;
                let qualifiedCategoryIdsArr = [];
                if(that.registerForm.qualifiedCategoryIds){
                    qualifiedCategoryIdsArr = that.registerForm.qualifiedCategoryIds.split(',');
                }
                for(let i=0; i < arr.length; i++){
                    if(qualifiedCategoryIdsArr.indexOf(arr[i].id) > -1){
                        arr[i]['disabled'] = true;
                    }else if(qualifiedCategoryIdsArr.indexOf(arr[i].id) == -1 && arr[i].children){
                        that.recursiveTreeData(arr[i].children);
                    }
                }
            },
            selectSuperiorName(){//加载供方分类树形数据
                this.recursiveTreeData(this.tree.supplierCategoryTreeData);
                this.tree.defaultKeys = (this.registerForm.supplierCategoryIds) ? this.registerForm.supplierCategoryIds.split(',') : [];
                this.tree.supplierCategoryDialog = true;
            },
            handleCloseSupplierCategory(){
                this.tree.supplierCategoryDialog = false;
            },
            handleConfirmSupplierCategory(){ //设置供方分类
                let that = this;
                let selectedData = this.$refs['treeSupplierCategory'].getCheckedNodes(true);
                let supplierCategoryIdsArr = [];
                let supplierCategoryNamesArr = [];
                for(let i=0; i<selectedData.length; i++){
                    supplierCategoryIdsArr.push(selectedData[i].id);
                    supplierCategoryNamesArr.push(selectedData[i].text);
                }
                //设置供方服务类别
                let selectedDataAll = this.$refs['treeSupplierCategory'].getCheckedNodes();
                let selectedDataHalf = this.$refs['treeSupplierCategory'].getHalfCheckedNodes();
                let selectedDataMain = selectedDataAll.concat(selectedDataHalf);
                let supplierServiceCategoryIdsArr = [];
                let supplierServiceCategoryNamesArr = [];
                for(let i=0; i<selectedDataMain.length; i++){
                    if(!selectedDataMain[i].parentId){
                        supplierServiceCategoryIdsArr.push(selectedDataMain[i].id);
                        supplierServiceCategoryNamesArr.push(selectedDataMain[i].text);
                    }
                }
                if(supplierServiceCategoryIdsArr.length == 0){
                    that.$alert('请选择供方分类', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return;
                }
                if(supplierServiceCategoryIdsArr.length > 1){
                    that.$alert('供方分类最多只能有一个一级分类', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return;
                }
                that.registerForm.supplierCategoryIds = supplierCategoryIdsArr.join(',');
                that.registerForm.supplierCategoryNames = supplierCategoryNamesArr.join(',');

                that.registerForm.supplierServiceCategoryIds = supplierServiceCategoryIdsArr.join(',');
                that.registerForm.supplierServiceCategoryNames = supplierServiceCategoryNamesArr.join(',');
                that.tree.supplierCategoryDialog = false;
            },
            handleCheckChange(data, node) {
                if(node.checked){
                    this.$refs['treeSupplierCategory'].setChecked(data.id, false, true);
                }else{
                    this.$refs['treeSupplierCategory'].setChecked(data.id, true, true);
                }

            },
            changeCompanyName(val){
//                console.log('change',val)
                var _this = this;
                if(val != window.sessionStorage.getItem('companyName')){
                    _this.$alert('供应商名称已变更，请上传"供方名称变更单(工商局盖章版)"附件!', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        callback: () => {
                            _this.activeName = '2';
                        }
                    });
                    _this.isChangeCompanyName = true;
                }
            },
            submit(){
                var _this = this;
//                cooperativeCategoryName  合作类别，需要传string
//                intentionRegionalCompanyIds 需要传字符串，传了数组，需要转成字符串
//                enterpriseRegistrationYear 需要传字符串，传了date;
                //整个表单验证
                _this.valid_first('submit');
                _this.valid_second();
                if(!_this.canSubmit) return;

                if(this.registerForm.creditLicenseCodeFlag == 2){
                    _this.$alert('请选择统一社会信用代码，并填写！不支持营业执照号！', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                    });
                   return;
                }

                if(!_this.registerForm.taxipayerStatus || !_this.registerForm.enterpriseRegistrationYear){
                    _this.$alert('请把带*的必填字段填写完整', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    return;
                }
                var formParams = {
                    "lstSuppliersContactInfoVO": _this.contactForm,//供方信息-联系方式
                    "lstSuppliersLastThreeMajorAchievenVO":  _this.strategyForm, //战略合作
                    "lstSuppliersLastThreeCommonAchievenVO": _this.commonForm, //一般合作
                    "lstSuppliersQualificationGradeVO": _this.naturalForm,//供方信息-资质等级
                    "lstSuppliersStockHolderVO": _this.partnerForm,//供方信息-股东
                    "suppliersBusinessSituationVO": _this.businessForm,//供方信息-业务状况
                    "suppliersObtainInformationVO": _this.InfoTypeForm,//供方信息-获取信息类型
                    "suppliersRelateParentCmpyVO": _this.affiliateForm,//关联母公司
                    "suppliersVO": _this.registerForm,//供方基本信息
                    "mapAttachmentVOs": {} //附件清单
                };

                formParams.suppliersVO.intentionRegionalCompanyIds = _this.registerForm.intentionRegionalCompanyIds;

                if(Array.isArray(_this.registerForm.undertakeAreas)){
                    formParams.suppliersVO.undertakeAreas = _this.registerForm.undertakeAreas.join(',');
                }
                let mapAttachmentVOs = {};
                for(let key in _this.mapAttachmentOptions){
                    mapAttachmentVOs[key] = _this.mapAttachmentOptions[key].fileList;
                }
                formParams.mapAttachmentVOs = mapAttachmentVOs;
//                如果修改了公司名称，那么就必须上传供应商名称变更单的附件
//                console.log('表单',formParams);/v1/sSuppliers/public/saveOrUpdateSuppliers
                function submitChange(){
                    _this.$root.postHttp('/v1/sSuppliers/outerUpdateSuppliers',formParams,function(res){
                        _this.$alert('操作成功', '提示', {
                            confirmButtonText: '确定',
                            type: 'success',
                            callback: action => {
                                if(_this.registerForm.companyName != window.sessionStorage.getItem('companyName')){
                                    window.sessionStorage.setItem('companyName',_this.registerForm.companyName)
                                }
                                _this.$router.push('/master/center');
                                _this.$root.activeIndex = 'home';
                            }
                        });
                    })
                }
                if(_this.qualifiedFlag == 1){
                    _this.$confirm('点击提交后需走变更审核流程，审核期间不允许修改，您确定提交吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        submitChange();
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消提交'
                        });
                    });
                } else {
                    submitChange();
                }
            },
            valid_second(){
                let _this = this;
                var strategyFormArr = [];
                if(_this.strategyForm.length && _this.strategyForm.cooperativeUnitName){
                    _this.strategyForm.forEach((item,i) => {
                        strategyFormArr.push('strategyForm'+i)
                    });
                }
                var commonFormArr = [];
                if(_this.commonForm.length && _this.commonForm.cooperativeUnitName){
                    _this.commonForm.forEach((item,i) => {
                        commonFormArr.push('commonForm'+i)
                    });
                }
                strategyFormArr = strategyFormArr.concat(commonFormArr);
                var isNext = true;
                if(!strategyFormArr.length){
                    _this.canSubmit = true;
                    return;
                }
                strategyFormArr.forEach((formName,index) => {
//                    console.log(1,formName,index,Array.isArray(_this.$refs[formName]))
                    let form = Array.isArray(_this.$refs[formName]) ? _this.$refs[formName][0] : _this.$refs[formName];
//                    console.log(2,form)
                    form.validate((valid) => {
                        if(!valid){
                            isNext = false;
                        }
                    });
                });
                if(isNext){
                    _this.canSubmit = true;
                } else {
                    _this.$alert('合作额度必须为数字', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        callback: () => {
                            _this.activeName = '1';
                        }
                    });
                    _this.canSubmit = false;
                }
            },
            valid_first(type){
                var _this = this;
                var arr_first = ['registerForm'];
                var naturalFormArr = [];
                _this.naturalForm.forEach((item,i) => {
                    naturalFormArr.push('naturalForm'+i)
                });
                var partnerFormArr = [];
                _this.partnerForm.forEach((item,i) => {
                    partnerFormArr.push('partnerForm'+i)
                });
                var contactFormArr = [];
                _this.contactForm.forEach((item,i) => {
                    contactFormArr.push('contactForm'+i)
                });
                arr_first = arr_first.concat(naturalFormArr,partnerFormArr,contactFormArr);
                arr_first.push('InfoTypeForm','affiliateForm','businessForm');
                var isSubmit = true;
                arr_first.forEach((formName,index) => {
//                    console.log(formName,index,_this.$refs[formName],Array.isArray(_this.$refs[formName]))
                    let form = Array.isArray(_this.$refs[formName]) ? _this.$refs[formName][0] : _this.$refs[formName];
                    form.validate((valid) => {
//                        console.log(valid)
                        if(!valid){
                            isSubmit = false;
                            return false;
                        }
                    });
                });
                if(isSubmit){
                    if(type == 'submit'){
                        for(var i in _this.mapAttachmentOptions) {
                            if(i == 2 || (i == 11 && _this.isChangeCompanyName)){
                                if(!_this.mapAttachmentOptions[i].fileList.length) {
                                    _this.$alert('带*的附件必须上传', '提示', {
                                        confirmButtonText: '确定',
                                        type: 'warning',
                                        callback: () => {
                                            _this.activeName = '2';
                                        }
                                    });
                                    _this.canSubmit = false;
                                    return;
                                }
                            } else {
                                _this.canSubmit = true;
                            }
                        }
                    } else {
                        _this.activeName = '1';
                    }

                } else {
                    _this.$alert('请把带*的必填字段填写完整', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                    _this.canSubmit = false;
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/var";
   /* body {
        background: $--primary-fill-color;
    }*/
    dl {
        margin: 0;
    }
    a {
        text-decoration: none;
    }
    /*banner*/
    .banner {
        margin-top: 80px;
        margin-bottom: 30px;
        & img {
            width: 100%;
            height: 140px;
        }
    }
    #basicInfo {
        padding-bottom: 80px;
        background: $--primary-fill-color;
        & .head-top{
            background: #fff;
        }
        .basicMain {
            background: #fff;
            padding-bottom: 30px;
        }
        /*审核记录，表格*/
        .recordTable {
            & th {
                text-align: center;
            }
            .el-table__body tr.current-row > td {
                background-color: #ebeef5;
            }
        }
        //审核记录弹出层表格
        .tableInfo {
            font-family: '宋体';
            th {
                text-align: center;
            }
            .el-table .cell {
                white-space: nowrap;
            }
            .tipStyle {
                width: 200px;
                white-space: normal;
            }
        }
    }
    #register {
        padding-bottom: 30px;
    }
    .el-pagination {
        margin:30px 0 40px;
    }
    /*注册须知*/
    #article {
        & .el-dialog {
            border-radius: 15px;
        }
        & .el-dialog__header {
            text-align: left;
            font-weight: bold;
            border-bottom: 1px solid $--text-color-light;
        }
        .el-dialog__title {
            padding-left: 30px;
            background: url('../../assets/images/register/icon_tit.png') no-repeat 0 1px;
        }
        .el-dialog--center .el-dialog__body {
            height: 320px;
            overflow-y: scroll;
        }
        & .center {
            text-align: center;
        }
        & section {
            margin-top: 15px;
            padding: 10px;
            color: $--primary-color;
            border: 1px solid $--secondary-fill-color;
        }
        & .padd {
            padding: 5px 0;
        }
        & .indent {
            text-indent: 28px;
        }
        & .indent2 {
            text-indent: 38px;
            /*padding: 0 14px;*/
        }
        & .readed {
            /*margin-top: 20px;*/
            padding: 15px;
            border-top: 1px dashed $--text-color-lighter;
            text-align: left;
        }
        & .el-button{
            padding: 10px 36px;
        }
        & .disagree {
            background: $--text-color-lighter;
            border: none;
        }
        & .el-dialog__footer {
            padding: 0 20px 20px;
        }
    }
    /*tab切换*/
    #basicInfo .el-tabs {
        padding-top: 20px;
        & .el-tabs__header {
            margin: 0 0 30px;
        }
        & .el-tabs__nav {
            margin-left: 40px;
        }
        & .el-tabs__item {
            font-size: 14px;
            height: 50px;
        }
        & .el-tabs__item.is-active {
            color: $--text-color;
            font-weight: 700;
        }
        & .el-tabs__active-bar {
            bottom: -2px;
            height: 12px;
            background: url('../../assets/images/register/at.png') no-repeat center 0;
        }
        & .el-tabs__nav-wrap::after {
            height: 1px;
            background-color: $--secondary-fill-color;
        }
    }
    #basicInfo .small-container {
        width: 1120px;
        margin: 0 auto;
        & form {
            width: 95%;
            margin: 15px auto;
            & .el-form-item__label {
                padding: 0 22px 0 0;
                color: #333;
            }
            & .el-form-item__content {
                width: 56%;
                text-align: left;
                & .el-select {
                    /*width: 35%;*/
                }
            }

            & .contentFull .el-form-item__content{
                width: 100%;
            }
            & .selectFull .el-select {
                width: 100%;
            }
            & .time .el-form-item__content {
                width: 80%;
            }
            & .validity .el-form-item__content {
                width: 100%;
            }
            & .unit {
                width: 85%;
                margin-right: 10px;
            }
            & .capital .el-form-item__content {
                width: 100%;
            }
            & .capital .unit {
                width: 28%;
            }
            & .veriCodeItem {
                position: relative;
                & input {
                    width: 60%;
                }
                & button {
                    position: absolute;
                    right: 0px;
                    top: 2px;
                }
                & .el-input__suffix {
                    right: 130px;
                }
                & .countDown {
                    position: absolute;
                    top: 2px;
                    color: $--primary-color;
                    border: 1px solid $--secondary-fill-color;
                    box-sizing: border-box;
                    height: 38px;
                    display: inline-block;
                    padding: 0 30px;
                    border-radius: 5px;
                    right: 20px;
                }
            }
            & .creditCode,
            & .capitalAddr,
            & .companyNature {
                position: relative;
                & .el-form-item__content>.el-input {
                    position: absolute;
                    right: 0;
                    top: 0;
                    width: 180px;
                }
            }
            & .creditCode {
                .el-form-item__content {
                    width:100%;
                }
                & .el-form-item__content>.el-input {
                    width: 220px;
                    right: 560px;
                }
                .tip {
                    margin-left: 250px;
                }
                & .el-form-item__error {
                    left: 30%;
                }
            }
            & .companyNature {
                & .el-form-item__content>.el-input {
                    right: 250px;
                }
            }
            & .capitalAddr .el-form-item__content {
                width: 70%;
                &>.el-input {
                    width: 80%;
                    position: static;
                }
                & .el-input__suffix {
                    right: 78px;
                }
            }
        }
        & .naturalForm  {
            padding: 20px 10px 5px;
            border: 1px solid #dcdfe6;
            border-radius: 3px;
            & .el-form-item__label {
                padding: 0;
            }
            & .el-form-item__content {
                width: 60%;
            }
        }
        & h3,
        & h4{
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }
        & .strategyForm {
            margin-top: 0;
            & h3 {
                margin: 0 0 30px;
            }
            & .tips {
                margin-right: 20px;
            }
        }
        & .tip {
            margin-left: 10px;
            color: $--primary-color;
            font-size: 12px;
        }
        & .tips {
            float: right;
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            color: $--text-color-lighter;
            background: url('../../assets/images/register/icon03.png') no-repeat left center;
        }
        & .add {
            float: right;
            font-size: 14px;
            cursor: pointer;
            & img {
                vertical-align: middle;
                width: 70px;
                height: 26px;
            }
        }
        & .dele img {
            transform: scale(1);
            transition: .5s;
            width: 34px;
            height: 34px;
        }
        .dele:hover img {
            transform: scale(1.1);
        }
        & .remarks {
            width: 95%;
        }
    }
    .uploadAnnex {
        overflow: hidden;
        & .el-upload {
            float: left;
        }
        & .el-upload-list {
            float: left;
            margin-left: 5px;
        }
        &>button {
            float: right;
            /*margin-right: 20px;*/
        }
    }
    #achievement .small-container form .unit {
        width: 85%;
        margin-right: 10px;
    }
    /*修改密码*/
    #changePass {
        position: relative;
        & main {
            width: 945px;
            & .right_text {
                margin: 0px auto;
                width: 400px;
                padding: 0px 35px 30px;
                background: #fff;
                /*box-shadow: 0 0 15px rgba(0,0,0,.2);*/
                & .el-form {
                    margin-top: 15px;
                    & .el-form-item {
                        border: 1px solid $--secondary-fill-color;
                        border-radius: 3px;
                        & .el-form-item__label {
                            padding: 0;
                        }
                        & .el-form-item__label::before {
                            content: '';
                            display: inline-block;
                            margin: 0 5px 0 5px;
                            vertical-align: middle;
                            width: 20px;
                            height: 20px;
                            background: url('../../assets/images/login/icon01.png') no-repeat 0 0;
                        }
                        & .el-form-item__content {
                            width: 280px;
                        }
                        & .el-input__inner {
                            border: none;
                            padding: 0;
                        }
                    }
                    & .el-form-item:nth-of-type(2),
                    & .el-form-item:nth-of-type(3) {
                        & .el-form-item__label::before {
                            background: url('../../assets/images/login/icon02.png') no-repeat 0 0;
                        }
                    }
                    & .el-form-item:nth-of-type(4) {
                        border: none;
                        & .el-form-item__content {
                            margin-left: 0;
                            & button {
                                width: 400px;
                                margin-left: -117px;
                            }
                        }
                    }
                }
                & .other {
                    overflow: hidden;
                    font-size: 12px;
                    cursor: pointer;
                    & .forgetPass {
                        float: left;
                        color: $--primary-color;
                    }
                    & p {
                        float: right;
                        color: $--text-color-lighter;
                        & .line {
                            margin: 0 8px;
                            border-left: 1px solid $--text-color-lighter;
                        }
                    }
                }
            }
        }
        & .copyright {
            margin-top: 50px;
            font-size: 12px;
            color: $--text-color-lighter;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/BasicInfo.vue